/* Rokiczanka – strony z tekstami: miniaturka teledysku + pasek zakupu na telefonie */
(function () {
  var root = document.getElementById('rk-song');
  if (!root) return;

  /* ---- 1. Teledysk: miniaturka zamiast zywej ramki YouTube ---- */
  var vbox = root.querySelector('.rokiczanka-video');
  var ifr = vbox ? vbox.querySelector('iframe') : null;
  if (vbox && ifr && ifr.src.indexOf('/embed/') > -1) {
    var id = ifr.src.split('/embed/')[1].split('?')[0].split('&')[0];
    var ttl = ifr.getAttribute('title') || 'Teledysk';
    if (id) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rk-yt';
      btn.setAttribute('aria-label', 'Odtworz teledysk');

      var img = document.createElement('img');
      img.alt = '';
      img.loading = 'lazy';

      /* YouTube nie ma kazdego rozmiaru miniaturki dla kazdego filmu.
         Gdy rozmiaru brak, i.ytimg.com oddaje szary zastepnik 120x90
         Z KODEM 200 – zdarzenie error sie nie odpala, wiec dodatkowo
         sprawdzamy szerokosc wczytanego obrazka i schodzimy nizej. */
      var sizes = ['maxresdefault', 'sddefault', 'hqdefault'];
      var si = 0;
      function rkSetThumb() {
        img.src = 'https://i.ytimg.com/vi/' + id + '/' + sizes[si] + '.jpg';
      }
      function rkNextThumb() {
        if (si < sizes.length - 1) { si++; rkSetThumb(); }
      }
      img.addEventListener('error', rkNextThumb);
      img.addEventListener('load', function () {
        if (img.naturalWidth && img.naturalWidth <= 121) rkNextThumb();
      });
      rkSetThumb();

      var play = document.createElement('span');
      play.className = 'rk-yt-play';

      btn.appendChild(img);
      btn.appendChild(play);
      btn.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id +
          '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
        f.title = ttl;
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        f.setAttribute('allowfullscreen', '');
        vbox.innerHTML = '';
        vbox.appendChild(f);
      });

      vbox.innerHTML = '';
      vbox.appendChild(btn);
    }
  }

  /* ---- 2. Przyklejony pasek zakupu na telefonie ---- */
  var prod = root.querySelector('#podklad');
  if (!prod) return;
  var cta = prod.querySelector('.rk-btn');
  var price = prod.querySelector('.rk-price');
  if (!cta || !price || !cta.getAttribute('href')) return;

  var nameEl = prod.querySelector('.rk-name');
  var coverEl = prod.querySelector('.rk-cover img');

  var bar = document.createElement('div');
  bar.className = 'rk-bar';

  if (coverEl) {
    var c = document.createElement('img');
    c.src = coverEl.getAttribute('src');
    c.alt = '';
    c.loading = 'lazy';
    bar.appendChild(c);
  }

  var txt = document.createElement('span');
  txt.className = 'rk-bar-t';
  var b = document.createElement('b');
  b.textContent = nameEl ? nameEl.textContent.trim() : 'Podklad bez wokalu';
  var i = document.createElement('i');
  i.textContent = price.textContent.trim();
  txt.appendChild(b);
  txt.appendChild(i);
  bar.appendChild(txt);

  var a = document.createElement('a');
  a.className = 'rk-bar-btn';
  a.href = cta.getAttribute('href');
  a.textContent = 'Kup';
  bar.appendChild(a);

  document.body.appendChild(bar);
  document.documentElement.classList.add('rk-has-bar');

  var ctaVisible = false;
  var on = false;

  function upd() {
    var v = (window.pageYOffset || document.documentElement.scrollTop) > 420 && !ctaVisible;
    if (v !== on) { on = v; bar.classList.toggle('on', v); }
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      ctaVisible = es[0].isIntersecting;
      upd();
    }, { rootMargin: '0px 0px -40px 0px' });
    io.observe(cta);
  }

  window.addEventListener('scroll', upd, { passive: true });
  window.addEventListener('resize', upd, { passive: true });
  upd();
})();
